// extracted by mini-css-extract-plugin
export default {"descriptionContainer":"VYE94I4_xKUKxFNnVU9g","icon":"DUb9Ho609llEhwUPwyjF"};